import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=3ea8bd08&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=ts"
export * from "./SearchBox.vue?vue&type=script&lang=ts"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=3ea8bd08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8bd08",
  null
  
)

export default component.exports